'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FeedbackBox = require('./FeedbackBox');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FeedbackBox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }